const StickmanFight = () => {
    return (
        <div>
            <p>
                This project was made for the Computer Graphics class.
                <br />
                This was a big project, since we had to do everything from scratch, but
                learned a lot in doing so. I was working on the 3D assets (models, animations in Blender),
                making a system to import those files, and everything from the camera, player movement,
                game logic, skeletal animations, and shaders. My colleague was working on the networking part of the project.
                <br />
                I believe this is the largest (and hardest) project me and my colleague have ever made,
                but it was really exciting and enlightening. Beside the technical part, another important
                lesson I learned was, when making things from scratch there is a lot more to do, than you initially think.
            </p>
        </div>
    )
}

export default StickmanFight;